// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {startCase} from 'lodash';

// Components
import Button from '../core/button';
import ForgotPasswordSuccess from './forgot-password-success';
import Form from '../core/form';
import Input from '../core/input';
import SubmitButton from '../core/submit-button';

// Styles
import './forgot-password.scss';

// Containers
import FormData from '../../containers/form-data';

const formName = 'forgotPassword';

function ForgotPassword({onReset}) {
    const getFormProps = (resetForm) => ({
        className: 'forgot-password--form',
        successPage: <ForgotPasswordSuccess {...{formName, onReset, resetForm}} />,
        fixedPositionedResponse: false,
        name: formName,
        noAuthenticationRequired: true,
        resetOnSubmit: true,
        submitData: true,
    });

    const getFieldProps = (fieldName, type) => ({
        className: 'forgot-password--input',
        label: startCase(fieldName),
        name: fieldName,
        type,
    });

    const handleReset = (event, resetForm) => {
        resetForm();
        onReset(event);
    };

    return (
        <div className="forgot-password">
            <FormData formName={formName}>
                {({resetForm}) => (
                    <Form {...getFormProps(resetForm)}>
                        <Input
                            {...getFieldProps('user')}
                            disableAutofill={true}
                            label="Username"
                            placeholder="Enter your username"
                            validate={['username']}
                        />
                        <SubmitButton className="forgot-password--submit-button" label="Submit" />
                        <Button
                            className="forgot-password--cancel-button"
                            onClick={(event) => handleReset(event, resetForm)}
                        >
                            Cancel
                        </Button>
                    </Form>
                )}
            </FormData>
        </div>
    );
}

ForgotPassword.propTypes = {
    onReset: PropTypes.func.isRequired,
};

export default ForgotPassword;
